/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxOpenDocsIcon32Regular = forwardRef('ArchiveBoxOpenDocsIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10 1a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H10Z" }),
        React.createElement("path", { d: "M12 16a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 8a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v3h1a2 2 0 0 1 2 2v11.5a4.5 4.5 0 0 1-4.5 4.5h-15A4.5 4.5 0 0 1 4 24.5V13a2 2 0 0 1 2-2h1V8Zm16 0v3H9V8a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1ZM6 13h20v11.5a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 6 24.5V13Z" })));
});
